const integrations = {
  backToIntegrations: 'Integrationen',
  enabled: 'AKTIVIERT',
  outOfService: 'Demnächst verfügbarÉ',
  enable: 'Aktivieren',
  updateIntegration: 'Aktualisieren',
  app: {
    actions: {
      disable: {
        button: 'Deaktivieren',
        success: 'Integration erfolgreich deaktiviert',
        failure: 'Beim Deaktivieren der Integration ist ein Fehler aufgetreten',
        confirmModal: {
          header: 'Trennung der Integration bestätigen',
          body: 'enter the word \'disable\' into the text field and confirm.,Um die Integration zu deaktivieren, geben Sie das Wort "Deaktivieren" in das Textfeld ein und bestätigen Sie., enter the word \'disable\' into the text field and confirm.',
          verificationPhrase: 'deaktivieren',
        },
      },
      oneTwoWayVerificationModal: {
        toOneWayInstructions: 'enter the word \'change\' into the text field and confirm.,Um die Integration auf 1-Weg umzustellen, geben Sie das Wort "Ändern\' in das Textfeld ein und bestätigen Sie., enter the word \'change\' into the text field and confirm.',
        toTwoWayInstructions: 'enter the word \'change\' into the text field and confirm.,Um die Integration auf 2-Wege umzustellen, geben Sie das Wort "Ändern" in das Textfeld ein und bestätigen Sie., enter the word \'change\' into the text field and confirm.',
        verificationPhrase: 'ändern',
      },
      submit: {
        success: 'Benutzerdefinierte Aktion erfolgreich eingeleitet',
        failure: 'Beim Starten der benutzerdefinierten Aktion ist ein Fehler aufgetreten.',
      },
    },
  },
  form: {
    submit: {
      enable: {
        success: 'Integration erfolgreich aktiviert. Benutzerdefinierte Aktionen wurden eingeleitet.',
        failure: 'Integration kann nicht aktiviert werden. Überprüfen Sie Ihre Konfiguration.',
      },
    },
  },
  categories: {
    all: 'Alle',
    communications: 'Kommunikation',
    dispatch: 'Versenden',
    finance: 'Finanzen',
    vehicleIntegration: 'Fahrzeugintegration',
  }
};

export default integrations;
